// Hilo de la Guarda — theme.js
// Sin dependencias externas (sin GSAP/AOS), replicando el patrón nativo del sitio de referencia.

(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Scroll-trigger fade-in ---------- */
  function initScrollTrigger() {
    var els = document.querySelectorAll(".scroll-trigger");
    if (!els.length) return;

    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("animate"); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Header: sección normal (se va con el scroll) + menú móvil ---------- */
  function initHeader() {
    var menuToggle = document.querySelector("[data-menu-toggle]");
    var menuPanel = document.querySelector("[data-mobile-menu]");
    var menuClose = document.querySelector("[data-menu-close]");
    var menuOverlay = document.querySelector("[data-menu-overlay]");

    function openMenu() {
      if (!menuPanel) return;
      menuPanel.classList.remove("-translate-x-full");
      menuOverlay.classList.remove("hidden");
      document.body.classList.add("overflow-hidden");
    }
    function closeMenu() {
      if (!menuPanel) return;
      menuPanel.classList.add("-translate-x-full");
      menuOverlay.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    }
    if (menuToggle) menuToggle.addEventListener("click", openMenu);
    if (menuClose) menuClose.addEventListener("click", closeMenu);
    if (menuOverlay) menuOverlay.addEventListener("click", closeMenu);
  }

  /* ---------- Búsqueda: overlay con input, mismo botón en mobile y desktop ---------- */
  function initSearch() {
    var overlay = document.querySelector("[data-search-overlay]");
    var toggles = document.querySelectorAll("[data-search-toggle]");
    var closeBtn = document.querySelector("[data-search-close]");
    var input = document.querySelector("[data-search-input]");
    if (!overlay || !toggles.length) return;

    function openSearch() {
      overlay.classList.remove("hidden");
      document.body.classList.add("overflow-hidden");
      if (input) {
        setTimeout(function () {
          input.focus();
        }, 50);
      }
    }
    function closeSearch() {
      overlay.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    }

    toggles.forEach(function (btn) {
      btn.addEventListener("click", openSearch);
    });
    if (closeBtn) closeBtn.addEventListener("click", closeSearch);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !overlay.classList.contains("hidden")) closeSearch();
    });
  }

  /* ---------- Add to cart (AJAX) ----------
     Ojo: esto SOLO debe engancharse a formularios marcados explícitamente con
     [data-ajax-cart] (las tarjetas de producto en grillas). El formulario de la
     página de producto (main-product.liquid) NO lleva ese atributo a propósito:
     apps como Releasit COD Form necesitan controlar ese submit sin competencia
     de otro listener global, o el pedido queda sin sesión de comprador válida. */
  function initAddToCart() {
    document.addEventListener("submit", function (e) {
      var form = e.target.closest("form[data-ajax-cart]");
      if (!form) return;
      var button = form.querySelector(".js-add-to-cart");
      if (!button) return;

      e.preventDefault();
      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = "Añadiendo…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(new FormData(form)),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("cart-add-failed");
          return res.json();
        })
        .then(function () {
          if (window.location.pathname === "/cart") {
            window.location.reload();
            return;
          }
          button.textContent = "Añadido ✓";
          updateCartCount();
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1600);
        })
        .catch(function () {
          button.textContent = "Error, intenta de nuevo";
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1800);
        });
    });
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var bubbles = document.querySelectorAll("[data-cart-count]");
        bubbles.forEach(function (b) {
          b.textContent = cart.item_count;
          b.classList.toggle("hidden", cart.item_count === 0);
        });
      });
  }

  /* ---------- Eliminar producto del carrito (página /cart) ---------- */
  function initCartRemove() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-cart-remove]");
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: btn.getAttribute("data-line"), quantity: 0 }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("cart-remove-failed");
          return res.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  }

  /* ---------- Cambiar cantidad en el carrito (página /cart) ----------
     Al editar la cantidad se actualiza el carrito con /cart/change.js y se vuelve a
     pintar el formulario con el HTML real de /cart, para que precios por línea,
     descuentos y subtotal salgan siempre del cálculo de Shopify. */
  function initCartQuantity() {
    var timer;
    var busy = false;

    function refresh(form) {
      return fetch("/cart", { headers: { "X-Requested-With": "fetch" }, credentials: "same-origin" })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.getElementById("cart");
          if (!fresh) { window.location.reload(); return; }
          form.innerHTML = fresh.innerHTML;
          initContinueShopping();
          updateCartCount();
        });
    }

    function apply(input) {
      var form = input.closest("form#cart");
      if (!form) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) return;
      var m = input.name.match(/^updates\[(\d+)\]$/);
      if (!m) return;

      busy = true;
      form.setAttribute("aria-busy", "true");
      form.style.opacity = "0.6";
      form.style.pointerEvents = "none";

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ line: parseInt(m[1], 10) + 1, quantity: qty }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("cart-change-failed");
          return refresh(form);
        })
        .catch(function () {
          window.location.reload();
        })
        .then(function () {
          busy = false;
          form.removeAttribute("aria-busy");
          form.style.opacity = "";
          form.style.pointerEvents = "";
        });
    }

    document.addEventListener("input", function (e) {
      var input = e.target;
      if (!input.matches || !input.matches('form#cart input[name^="updates["]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () { if (!busy) apply(input); }, 600);
    });

    document.addEventListener("change", function (e) {
      var input = e.target;
      if (!input.matches || !input.matches('form#cart input[name^="updates["]')) return;
      clearTimeout(timer);
      if (!busy) apply(input);
    });
  }

  /* ---------- Carrusel: flechas + puntos (colecciones destacadas, grids de producto) ---------- */
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  /* Animación de scroll propia (no depende de scrollBehavior nativo del navegador,
     que en algunos entornos/versiones falla silenciosamente junto con scroll-snap). */
  function animateScrollTo(el, targetLeft, duration) {
    var startLeft = el.scrollLeft;
    var distance = targetLeft - startLeft;
    var startTime = null;
    duration = duration || 400;

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      el.scrollLeft = startLeft + distance * easeInOutQuad(progress);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initScrollers() {
    document.querySelectorAll("[data-scroller]").forEach(function (scroller) {
      var wrap = scroller.closest("[data-scroller-wrap]") || scroller.parentElement;
      var prev = wrap.querySelector("[data-scroller-prev]");
      var next = wrap.querySelector("[data-scroller-next]");
      var dotsContainer = wrap.parentElement ? wrap.parentElement.querySelector("[data-scroller-dots]") : null;
      var items = Array.prototype.slice.call(scroller.children);
      if (!items.length) return;

      var activeIndex = 0;
      var maxLeft = function () { return scroller.scrollWidth - scroller.clientWidth; };
      var amount = function () { return scroller.clientWidth * 0.9; };
      var scrollToItem = function (i) {
        i = Math.max(0, Math.min(items.length - 1, i));
        animateScrollTo(scroller, items[i].offsetLeft - scroller.offsetLeft);
      };

      if (prev) {
        prev.addEventListener("click", function () {
          animateScrollTo(scroller, Math.max(0, scroller.scrollLeft - amount()));
          stopAutoplay();
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          animateScrollTo(scroller, Math.min(maxLeft(), scroller.scrollLeft + amount()));
          stopAutoplay();
        });
      }

      var dots = [];
      if (dotsContainer) {
        dotsContainer.innerHTML = "";
        items.forEach(function (item, i) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "scroller-dot";
          dot.setAttribute("aria-label", "Ir al elemento " + (i + 1));
          dot.addEventListener("click", function () {
            scrollToItem(i);
            stopAutoplay();
          });
          dotsContainer.appendChild(dot);
          dots.push(dot);
        });
      }

      var updateState = function () {
        var scrollLeft = scroller.scrollLeft;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;

        if (prev) prev.disabled = scrollLeft <= 4;
        if (next) next.disabled = scrollLeft >= maxScroll - 4;

        var closest = 0;
        var closestDist = Infinity;
        items.forEach(function (item, i) {
          var dist = Math.abs(item.offsetLeft - scroller.offsetLeft - scrollLeft);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        activeIndex = closest;

        if (dots.length) {
          dots.forEach(function (d, i) { d.classList.toggle("is-active", i === closest); });
        }
      };

      scroller.addEventListener("scroll", debounce(updateState, 100), { passive: true });
      window.addEventListener("resize", debounce(updateState, 200));
      updateState();

      /* Autoplay opcional (Hero): [data-scroller-wrap] con data-autoplay="<ms>".
         Se detiene con la interacción del usuario (flechas, puntos, hover, touch)
         y se reanuda al dejar de interactuar, salvo que prefiera menos movimiento. */
      var autoplayMs = parseInt(wrap.dataset.autoplay, 10);
      var autoplayTimer = null;
      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }
      function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          scrollToItem((activeIndex + 1) % items.length);
        }, autoplayMs);
      }
      if (autoplayMs && items.length > 1 && !reduceMotion) {
        startAutoplay();
        wrap.addEventListener("mouseenter", stopAutoplay);
        wrap.addEventListener("mouseleave", startAutoplay);
        wrap.addEventListener("touchstart", stopAutoplay, { passive: true });
      }
    });
  }

  /* ---------- Barra de anuncio: rotación de mensajes ---------- */
  function initAnnouncementBar() {
    document.querySelectorAll("[data-announcement-bar]").forEach(function (bar) {
      var slides = bar.querySelectorAll("[data-announcement-slide]");
      if (slides.length < 2 || reduceMotion) return;

      var interval = (parseInt(bar.getAttribute("data-interval"), 10) || 4) * 1000;
      var current = 0;

      setInterval(function () {
        slides[current].classList.add("opacity-0");
        current = (current + 1) % slides.length;
        slides[current].classList.remove("opacity-0");
      }, interval);
    });
  }


  /* ---------- Seguir comprando (volver a donde estaba el cliente) ----------
     Guarda la última página de catálogo (home, colección, producto, búsqueda) y su
     scroll en sessionStorage; el botón de /cart ([data-continue-shopping]) vuelve ahí. */
  var LAST_KEY = "hdg:last-shop";
  var RESTORE_KEY = "hdg:restore-scroll";

  function isShopPage(path) {
    return path === "/" || ["/collections", "/products", "/search"].some(function (p) { return path === p || path.indexOf(p + "/") === 0; });
  }

  function initContinueShopping() {
    var path = window.location.pathname;

    try {
      if (isShopPage(path)) {
        var save = function () {
          try {
            sessionStorage.setItem(LAST_KEY, JSON.stringify({
              url: path + window.location.search,
              y: Math.round(window.scrollY || 0),
            }));
          } catch (e) {}
        };
        save();
        window.addEventListener("pagehide", save);

        var pending = sessionStorage.getItem(RESTORE_KEY);
        if (pending) {
          sessionStorage.removeItem(RESTORE_KEY);
          var data = JSON.parse(pending);
          if (data && data.url === path + window.location.search && data.y > 0) {
            window.addEventListener("load", function () {
              window.scrollTo(0, data.y);
            });
          }
        }
      }
    } catch (e) {}

    document.querySelectorAll("[data-continue-shopping]").forEach(function (link) {
      try {
        var last = JSON.parse(sessionStorage.getItem(LAST_KEY) || "null");
        if (last && last.url) link.setAttribute("href", last.url);
        link.addEventListener("click", function () {
          try { if (last) sessionStorage.setItem(RESTORE_KEY, JSON.stringify(last)); } catch (e) {}
        });
      } catch (e) {}
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initScrollTrigger();
    initHeader();
    initSearch();
    initAddToCart();
    initCartRemove();
    initCartQuantity();
    initContinueShopping();
    initScrollers();
    initAnnouncementBar();
  });
})();
